import SupplementPrompt from "@/data/interfaces/SupplementPrompt";
import adminService from "@/services/adminService";
import { useEffect, useState } from "react";
import { ErrorMessage } from "@/components/UI";
import SimplePromptForm from "../Shared/PromptManagement/SimplePromptForm";
import PromptList from "../Shared/PromptManagement/PromptList";
import { adminStatusBadgeClass } from "../../Shared/adminUi";

const SupplementPrompts = () => {
  const [prompts, setPrompts] = useState<SupplementPrompt[] | undefined>();
  const [editingPrompt, setEditingPrompt] = useState<
    SupplementPrompt | undefined
  >();
  const [errorMessage, setErrorMsg] = useState<string>();

  useEffect(() => {
    loadPrompts();
  }, []);

  const loadPrompts = async () => {
    try {
      const promptsData = await adminService.supplementPrompt.getAll();
      setPrompts(promptsData);
    } catch (error) {
      console.error(error);
      setErrorMsg(`NEPAVYKO GAUTI PROMPTŲ: ${error}`);
    }
  };

  const addNewPrompt = async (content: string) => {
    try {
      setErrorMsg(undefined);
      await adminService.supplementPrompt.create(content);
      loadPrompts();
    } catch (error) {
      console.error(error);
      setErrorMsg(`NEPAVYKO PRIDĖTI NAUJO PROMPTO: ${error}`);
    }
  };

  const updatePrompt = async (prompt: SupplementPrompt) => {
    try {
      setErrorMsg(undefined);
      await adminService.supplementPrompt.update(prompt);
      setEditingPrompt(undefined);
      loadPrompts();
    } catch (error) {
      console.error(error);
      setErrorMsg(`NEPAVYKO ATNAUJINTI PROMPTĄ: ${error}`);
    }
  };

  const deletePrompt = async (prompt: SupplementPrompt) => {
    try {
      setErrorMsg(undefined);
      await adminService.supplementPrompt.delete(prompt.id);
      loadPrompts();
    } catch (error) {
      console.error(error);
      setErrorMsg(`NEPAVYKO IŠTRINTI PROMPTĄ: ${error}`);
    }
  };

  return (
    <>
      <div className="flex flex-col-reverse gap-8 md:flex-row md:gap-4">
        <div className="flex flex-col gap-2 md:w-fit md:min-w-[200px] lg:min-w-[350px]">
          <SimplePromptForm
            onSubmit={addNewPrompt}
            onUpdate={updatePrompt}
            editingPrompt={editingPrompt}
            onCancelEdit={() => setEditingPrompt(undefined)}
            title="Pridėti naują prompt:"
          />

          <ErrorMessage error={errorMessage} />
        </div>

        <PromptList
          prompts={prompts}
          onDeletePrompt={deletePrompt}
          onEditPrompt={setEditingPrompt}
          title="Supplement Prompts"
          renderPromptBadges={(prompt) => (
            <span className={adminStatusBadgeClass(!!prompt.is_active)}>
              {prompt.is_active ? "Aktyvus" : "Neaktyvus"}
            </span>
          )}
        />
      </div>
    </>
  );
};

export default SupplementPrompts;
